import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { useRouterContext } from "../services/router/routerContext";
import style from './About.module.css';

export const Message: React.FC = () => {

    const { t } = useTranslation();
    const {routerMessage} = useRouterContext();

    return <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={style.loading}
        style={{ position: 'absolute', inset: 0 }}
    >
        <div className={style.container}>
            {routerMessage && t(routerMessage)}
        </div>
    </motion.div>
}